interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', schema }: SEOHeadProps) {
  const fullTitle = `${title} | 桃子视频`;
  const ogData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桃子视频',
    url: 'https://taozivideo.com',
    description: '桃子视频🎯数字系列视频平台，91视频、97视频、📌51视频等热门资源免费高清在线看，电视剧电影全集不缓冲。',
  };

  const websiteData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '桃子视频',
    url: 'https://taozivideo.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://taozivideo.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: fullTitle,
    description,
    url: canonicalUrl,
    isPartOf: {
      '@type': 'WebSite',
      name: '桃子视频',
      url: 'https://taozivideo.com',
    },
  };

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <script type="application/ld+json">{JSON.stringify(ogData)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteData)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageData)}</script>
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </>
  );
}